import * as React from "react";
import { Typography, Box, Card, CardContent } from "@mui/material";
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { centered_flex_box } from "../../app/components/Styles";
import { getInbounds } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import InboundDocumentsTable from "../../app/components/InboundDocumentsTable";

export const OutboundsList = ({ getInbounds, inbounds, isLoading }) => {
  const [searchParams] = useSearchParams();
  const ops = searchParams.get("ops") || "delayed";
  const [page, setPage] = React.useState(1);

  useEffect(() => {
    getInbounds({
      page,
      limit: 100,
      direction: "Out",
      ops: ops === "delayed" ? "delayed" : undefined,
    });
  }, [page, ops, getInbounds]);

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 2, justifyContent: "space-between" }}>
          <Typography variant="h4" sx={{ color: "var(--secColor)" }}>
            {ops === "delayed" ? "Delayed Outbounds" : "Outbounds"}
          </Typography>
        </Box>
        {ops === "delayed" && (
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography color="text.secondary">
                Outbound POs not Received or Cancelled, created more than 2 working days ago (Friday off), from 1 June 2026 onward.
              </Typography>
            </CardContent>
          </Card>
        )}
        <InboundDocumentsTable
          inbounds={inbounds?.docs}
          pagination={inbounds}
          page={page}
          setPage={setPage}
          loading={isLoading}
        />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  inbounds: state?.records?.inbounds,
});

const mapDispatchToProps = { getInbounds };

export default connect(mapStateToProps, mapDispatchToProps)(OutboundsList);
